import React, { useContext, useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Icon, Header, Button } from 'semantic-ui-react';
import EmployeeCertificateStore from '../../stores/employeecertificateStore';

interface IProps {
  name: string;
  category: string;
}

const dropzoneStyles = {
  // border: 'dashed 3px',
  // borderColor: 'transparent',
  // borderRadius: '5px',
  // paddingTop: '30px',
  textAlign: 'center' as 'center',
  // height: '50px'
};

const dropzoneActive = {
  border: 'dashed 3px',
  borderColor: 'blue',
  borderRadius: '5px',
  height: '50px',
  width: '50px',
  backgroundColor: 'grey'
};



const CertificatePhotoDropzone: React.FC<IProps> = ({ name, category }) => {
  const employeecertificateStore = useContext(EmployeeCertificateStore);
  const {uploadPhoto} = employeecertificateStore;

  // const [files, setFiles] = useState<File[]>([]);

  const onDrop = useCallback(acceptedFiles => {
    uploadPhoto(acceptedFiles, name, category).then(()=> acceptedFiles.length = 0);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  // const { getRootProps, getInputProps, isDragActive, acceptedFiles } = useDropzone();
  // const files = acceptedFiles.map(file => {
  //   var count = acceptedFiles.length;
  //   uploadPhoto(file, photoInfo, count);
  //   return <li key={file.name}>
  //   {file.name} - {file.size} bytes
  // </li>
  // });

 // uploadPhoto(acceptedFiles, photoInfo).then(()=> acceptedFiles.length = 0);

  return (
    <section>
      <div
        {...getRootProps()}
        style={
          isDragActive ? { ...dropzoneStyles, ...dropzoneActive } : dropzoneStyles
        }
      >
        <input {...getInputProps()} />
        {/* <Icon name='upload' size='big' /> */}
        {(category === 'Certificate' ) ? 'Upload' : 
             <Button size='mini'
                  icon="upload"
                  color="grey"
                  title="Upload"
                  />}
        {/* <Header content='Click here' /> */}

      </div>
      {/* <ul>{files}</ul> */}

    </section>
  );
};

export default CertificatePhotoDropzone;
